import React from "react";
import aboutImg from "../assets/images/about-img.jpg";
import iconExperience from "../assets/images/icon-experience.svg";

import iconNutrition from "../assets/images/icon-about-us-1.svg";
import iconProActive from "../assets/images/icon-about-us-2.svg";
import iconWorkout from "../assets/images/icon-about-us-3.svg";
import iconSupport from "../assets/images/icon-about-us-4.svg";

import iconCounter1 from "../assets/images/icon-counter-1.svg";
import iconCounter2 from "../assets/images/icon-counter-2.svg";
import iconCounter3 from "../assets/images/icon-counter-3.svg";
import iconCounter4 from "../assets/images/icon-counter-4.svg";

import iconMission from "../assets/images/icon-our-mission.svg";
import iconVision from "../assets/images/icon-our-vision.svg";
import iconApproach from "../assets/images/icon-our-approch.svg";
import iconCta from "../assets/images/icon-cta.svg";

import therapyProcess1 from "../assets/images/therapy-process-1.jpg";
import therapyProcess2 from "../assets/images/therapy-process-2.jpg";
import therapyProcess3 from "../assets/images/therapy-process-3.jpg";
import therapyProcess4 from "../assets/images/therapy-process-4.jpg";
import { Helmet } from "react-helmet-async";

export default function About() {


  return (
    <>
      <Helmet>
  <title>About BrightLife Physio Point | Expert Physiotherapy Team</title>
  <meta
    name="description"
    content="Meet the experienced physiotherapists and specialists at BrightLife Physio Point, Hyderabad."
  />
</Helmet>
      <div className="page-header">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box">
                <h1 className="text-anime-style-2" data-cursor="-opaque">
                  About Us
                </h1>
                <nav>
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <a href="/">Home</a>
                    </li>
                    <li className="breadcrumb-item active">About Us</li>
                  </ol>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ABOUT SECTION */}
      <div className="about-us page-about-us">
        <div className="container">
          <div className="row align-items-center">
            
            {/* LEFT IMAGE */}
            <div className="col-lg-6">
              <div className="about-us-image">
                <div className="about-img">
                  <figure className="image-anime">
                    <img loading="lazy" src={aboutImg} alt="Brightlife Physio" />
                  </figure>

                  <div className="company-experience">
                    <div className="icon-box">
                      <img loading="lazy" src={iconExperience} alt="" />
                    </div>
                    <div className="company-experience-content">
                      <h3>
                        <span className="counter">15</span>+
                      </h3>
                      <p>Years of Experience</p> 
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* RIGHT CONTENT */}
            <div className="col-lg-6">
              <div className="about-content">
                <div className="section-title">
                  <h3>About Us</h3>
                  <h4 className="text-anime-style-2" data-cursor="-opaque">
                    At Brightlife Physio Point, we don't chase pain—we restore balance, precision, and intelligent movement for a higher standard of living. 
                  </h4>
                   <p className="wow fadeInUp" data-wow-delay="0.25s">
                    At Brightlife Physio Point, we believe healing goes beyond
                    treating symptoms—it's about restoring natural movement,
                    strength, and confidence. We offer a blend of advanced
                    physiotherapy techniques and holistic therapies to provide
                    complete, personalized care for every individual.
                  </p>
                  <p className="wow fadeInUp" data-wow-delay="0.5s">
                    With over 15 years of clinical experience, our skilled team
                    focuses on accurate assessment, hands-on treatment, and
                    evidence-based rehabilitation to help you recover faster and
                    live pain-free. From musculoskeletal issues and sports
                    injuries to chronic pain and posture correction, every
                    treatment plan is tailored to your unique needs.
                  </p>
                  <p className="wow fadeInUp" data-wow-delay="0.75s">
                    Our specialized services include Physiotherapy, Osteopathy,
                    Chiropractic Care, Neuro Kinetic Therapy (NKT), Anatomy
                    Trains & Structural Integration, Acupuncture & Dry Needling,
                    Craniosacral Therapy, and Matrix Rhythm Therapy. Whether you
                    are an athlete aiming for top performance or someone seeking
                    long-term relief, we guide your healing journey with
                    expertise and compassion.
                  </p>
                  <p className="wow fadeInUp" data-wow-delay="1s">
                    At Brightlife, your health, mobility, and overall well-being
                    are our top priority.
                  </p>
                </div>

                {/* LIST */}
              

                {/* DOCTOR INFO + BUTTON */}
                <div className="about-us-footer">
                  

                  {/* <div className="appointment-btn">
                    <a href="/appointment" className="btn-default">
                      Make an Appointment
                    </a>
                  </div> */}
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>

      {/* COUNTERS */}
      <div className="company-counter">
        <div className="container">
          <div className="row">
            
            <div className="col-lg-3 col-md-6">
              <div className="company-counter-item">
                <div className="icon-box">
                  <img loading="lazy" src={iconCounter1} alt="" />
                </div>
                <div className="company-counter-content">
                  <h3>
                    <span className="counter">10</span>+
                  </h3>
                  <p>Specialised Therapists</p>
                </div>
              </div>
            </div>

            <div className="col-lg-3 col-md-6">
              <div className="company-counter-item">
                <div className="icon-box">
                  <img loading="lazy" src={iconCounter2} alt="" />
                </div>
                <div className="company-counter-content">
                  <h3>
                    <span className="counter">98</span>%
                  </h3>
                  <p>Patients Showing Improvement</p>
                </div>
              </div>
            </div>

            <div className="col-lg-3 col-md-6">
              <div className="company-counter-item">
                <div className="icon-box">
                  <img loading="lazy" src={iconCounter3} alt="" />
                </div>
                <div className="company-counter-content">
                  <h3>
                    <span className="counter">25000</span>+
                  </h3>
                  <p>Patients Treated</p>
                </div>
              </div>
            </div>

            <div className="col-lg-3 col-md-6">
              <div className="company-counter-item">
                <div className="icon-box">
                  <img loading="lazy" src={iconCounter4} alt="" />
                </div>
                <div className="company-counter-content">
                  <h3>
                    <span className="counter">15</span>+
                  </h3>
                  <p>Years of Experience</p>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>

      {/* MISSION - VISION - APPROACH */}
      <div className="mission-vision">
        <div className="container">

          <div className="row section-row">
            <div className="section-title">
              <h3>Vision to Victory</h3>
              <h2 className="text-anime-style-2">
                <span>We're a Recognized</span> & Quality Leader
              </h2>
            </div>
          </div>

          <div className="row">

            <div className="col-lg-6 col-md-6">
              <div className="our-mva-item">
                <div className="icon-box">
                  <img loading="lazy" src={iconMission} alt="" />
                </div>
                <div className="mva-item-content">
                  <h3>Our Mission</h3>
                  <p>
                   To restore balance, intelligence, and freedom of movement in every individual by addressing pain and dysfunction at its true source—physical, emotional, and visceral—through deeply personalised, integrated therapeutic care.</p><br/>
 <p>
We exist to go beyond symptom relief, offering thoughtfully designed, tailor-made protocols that recalibrate posture, movement, and internal harmony—so the body functions not just pain-free, but optimally.</p>
                </div>
              </div>
            </div>

            <div className="col-lg-6 col-md-6">
              <div className="our-mva-item">
                <div className="icon-box">
                  <img loading="lazy" src={iconVision} alt="" />
                </div>
                <div className="mva-item-content">
                  <h3>Our Vision</h3>
                  <p>
                   To be a trusted centre of excellence in integrative physical medicine, where precision diagnosis, advanced therapeutic integration, and conscious care redefine the standards of healing and prevention.
                  </p><br/>
                  <p>
                    We envision a future where pain is not managed temporarily but resolved intelligently, where movement is balanced, posture is resilient, and individuals experience a higher quality of life through refined, premium therapeutic interventions.
                  </p>
                </div>
              </div>
            </div>

          

          </div>

          {/* CTA */}
          <div className="cta-infobar">
            <div className="row align-items-center">
              <div className="col-lg-6">
                <div className="cta-info-content">
                  <div className="icon-box">
                    <img loading="lazy" src={iconCta} alt="" />
                  </div>
                  <div className="cta-content">
                    <h3>Ready to start your journey to recovery?</h3>
                    <p>
                      Contact us today for your initial consultation and take
                      the first step toward a pain-free life.
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-lg-6">
                <div className="cta-appointment-btn">
                   <a
                    href="https://wa.me/919000666889?text=Hi%20BrightLife%20Physio%20Point,%20I%20would%20like%20to%20book%20an%20appointment."
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn-default"
                  >
                    Book Appointment
                  </a>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>

      {/* THERAPY PROCESS */}
      <div className="quality-treatment therapy-process">
        <div className="container">

          <div className="row section-row">
            <div className="col-lg-12">
              <div className="section-title">
                <h3>Therapy Process</h3>
                <h2 className="text-anime-style-2">
                  <span>What</span> is Therapy Process
                </h2>
              </div>
            </div>
          </div>

          <div className="row">

            <div className="col-lg-3 col-md-6">
              <div className="therapy-process-item">
                <div className="icon-box">
                  <figure className="image-anime">
                    <img loading="lazy" src={therapyProcess1} alt="" />
                  </figure>
                </div>
                <div className="therapy-process-content">
                  <h3>Get paired with a therapist</h3>
                  <p>
                    We assess your pain, posture and movement to match you with
                    the right therapist.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-lg-3 col-md-6">
              <div className="therapy-process-item">
                <div className="icon-box">
                  <figure className="image-anime">
                    <img loading="lazy" src={therapyProcess2} alt="" />
                  </figure>
                </div>
                <div className="therapy-process-content">
                  <h3>Choose your preferred care</h3>
                  <p>
                    We create a customised treatment plan that fits your
                    schedule and lifestyle.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-lg-3 col-md-6">
              <div className="therapy-process-item">
                <div className="icon-box">
                  <figure className="image-anime">
                    <img loading="lazy" src={therapyProcess3} alt="" />
                  </figure>
                </div>
                <div className="therapy-process-content">
                  <h3>We help you get better faster</h3>
                  <p>
                    Hands-on therapy, exercises and continuous progress tracking
                    help you recover quickly.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-lg-3 col-md-6">
              <div className="therapy-process-item">
                <div className="icon-box">
                  <figure className="image-anime">
                    <img loading="lazy" src={therapyProcess4} alt="" />
                  </figure>
                </div>
                <div className="therapy-process-content">
                  <h3>What physiotherapy helps with</h3>
                  <p>
                    Neck pain, back pain, knee pain, shoulder injuries, sports
                    injuries, posture issues & more.
                  </p>
                </div>
              </div>
            </div>

          </div>

        </div>
      </div>
    </>
  );
}
